<form #formEl [formGroup]="formGroup" class="left">
  <!-- <wz-health-vad-alert style="display: none;"></wz-health-vad-alert> -->

  <!-- <wz-form-group  [expandable]="true" [expanded]="true" [disabled]="disabled">
    <wz-form-group-header>
      <mat-icon>person</mat-icon>
      Assuré principal
    </wz-form-group-header> -->

  <!-- *****************Health Assure Form **************-->
  <wz-health-assure-formB2C
    (regimeSocial)="newRegimeSocial($event)"
    (dateEffet)="newDateEffet($event)"
    [package]="package"
    [formula]="formula"
    (submitEvent)="receiveSubmit($event)"
  >
  </wz-health-assure-formB2C>
  <!-- </wz-form-group> -->

  <wz-form-group
    [expandable]="true"
    [expanded]="true"
    [disabled]="disabled"
    style="display: none"
  >
    <wz-form-group-header>
      <mat-icon>people</mat-icon>
      Famille de l'assuré
    </wz-form-group-header>

    <wz-health-family-form
      [regimeSocial]="regimeSocial"
      [dateEffet]="dateEffet"
      [package]="package"
      [formula]="formula"
    >
    </wz-health-family-form>
  </wz-form-group>

  <wz-form-group
    [expandable]="true"
    [expanded]="true"
    [disabled]="disabled"
    style="display: none"
  >
    <wz-form-group-header>
      <mat-icon>people</mat-icon>
      Besoins de l'assuré
    </wz-form-group-header>
  </wz-form-group>
</form>
